import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { usersApi } from '../../api/users';
import { GQLArgs, ErrorForToast } from '../../types';
import { AxiosError } from 'axios';

type CreateUserResponse = { createUser: any };

export const useMutationCreateUser = (args?: GQLArgs<CreateUserResponse>) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<CreateUserResponse | undefined>();

  const mutation = useCallback(
    async ({ variables }: { variables: any }) => {
      setLoading(true);
      try {
        const res = await usersApi.create(
          {
            email: variables.email,
            full_name: variables.fullName,
            speciality: variables.speciality,
            ref_id: variables.refId,
          },
          variables.role,
        );
        const shaped: CreateUserResponse = { createUser: res.data };
        setData(shaped);
        args?.onCompleted?.(shaped);
        toast.success('User has been created', { autoClose: 5000 });
        return shaped;
      } catch (err: any) {
        const axiosError = err as AxiosError<{
          code?: string;
          message?: string;
          extra?: Record<string, any>;
        }>;
        const status = axiosError.response?.status;
        const body = axiosError.response?.data;

        if (status === 422 && body?.extra?.details) {
          const details = body.extra.details;
          const errorMessages: ErrorForToast[] = Object.keys(details).map((key) => ({
            name: key,
            errors: Array.isArray(details[key]) ? details[key] : [details[key]],
          }));
          args?.onUIError?.(errorMessages);
        }

        args?.onError?.(err);
      } finally {
        setLoading(false);
      }
    },
    [args],
  );

  return { mutation, data, loading, error: undefined };
};
